import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import AppInstallBanner from "@/components/AppInstallBanner";
import { useLocation } from "react-router-dom";

export default function WebShell({ children }) {
  const location = useLocation();
  const isFeedbackRoute = location.pathname.startsWith("/avaliar");

  return (
    <>
      {!isFeedbackRoute && <Navbar />}
      <main>
        {children}
      </main>
      {!isFeedbackRoute && <Footer />}
      {!isFeedbackRoute && <AppInstallBanner />}
      <Toaster position="top-right" />
    </>
  );
}
